<template>
  <div>
    <!-- loading page indicator -->
    <template v-if="isLoadingPage">
      <pre-loader />
    </template>

    <!-- page data -->
    <template v-if="!isLoadingPage">
      <section>
        <div class="section--title">
          <h1>Roles</h1>
          <hr />
        </div>
      </section>
      <section class="mt-5">
        <div class="row">
          <div class="col-12">
            <div class="card border-0">
              <div class="card-body">
                <roles-table
                  :roles="roles"
                  @updateRoles="getRoles(false)"
                  @showRoleForm="showRoleForm"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <RolesModal :title="modalTitle">
        <template v-if="modalTitle === 'create'">
          <CreateRoleForm
            :permissions="permissions"
            @updateRolesTable="getRoles"
          />
        </template>
        <template v-else>
          <EditUserRoleForm
            ref="userRoleForm"
            :permissions="permissions"
            @updateRolesTable="getRoles"
          />
        </template>
      </RolesModal>
    </template>

  </div>
</template>

<script>
import RolesTable from '@/components/tables/userManagement/RolesTable'
import RolesModal from '@/components/modals/users/RoleModal'
import CreateRoleForm from '@/components/forms/users/role/CreateRoleForm'
import EditUserRoleForm from '@/components/forms/users/role/EditRoleForm'
export default {
  components: {
    RolesTable,
    RolesModal,
    CreateRoleForm,
    EditUserRoleForm
  },
  data() {
    return {
      roles: [],
      isLoadingPage: true,
      modalTitle: 'Create',
      role: {},
      permissions: []
    }
  },
  methods: {
    async getRoles(showLoadingIndicator) {
      if(showLoadingIndicator) {
        this.isLoadingPage = true
      }
      try {
        const { data: roles } = await this.$repos.userManagementRepo.getRoles();
        this.roles = roles
      }catch(error) {
        console.log(error)
      }finally {
        this.isLoadingPage = false
      }
    },
    async getpermissions() {
      try {
        const { data: permissions } = await this.$repos.userManagementRepo.getPermissions();
        this.permissions = permissions
      }catch(error) {
        console.log(error)
      }
    },
    showRoleForm(role) {
      this.modalTitle = role.type
      if(role.type === 'edit'){
        this.$refs.userRoleForm.setRole(role.role)
      }
      this.role = {...role.role}
      $('#rolesModal').modal({
        show: true,
        backdrop: 'static'
      })
    }
  },
  async mounted() {
    await this.getRoles(true)
    await this.getpermissions()
  }
}
</script>